import ButtonComponent from "../../components/common/button/Button";
import Modal from "../../components/common/modal/Modal";
import "./DeleteTrainingContentModal.css";

export const DeleteTrainingContentModal = ({
    openDeleteConfirmationModalData,
    handleCloseDeleteModal,
    handleDeleteConfirmation,
    selectedTopic,
}) => {
    return (
        <Modal
            className="DeleteTrainingContentModal_cls"
            open={openDeleteConfirmationModalData}
            handleClose={handleCloseDeleteModal}
            title={"Delete Training Topic"}
            fullWidth={true}
            maxWidth={"sm"}
            action={
                <DeleteTrainingContentModalFooter
                    onClickCancel={handleCloseDeleteModal}
                    onClickYes={handleDeleteConfirmation}
                />
            }
            content={
                <DeleteTrainingContent
                    selectedTopic={selectedTopic}
                />
            }
        />
    );
};

const DeleteTrainingContentModalFooter = ({
    onClickCancel,
    onClickYes,
}) => {
    return (
        <div
            className="btn-wrapper"
            style={{ display: "flex", gap: 10 }}
        >
            <ButtonComponent
                label="No"
                type="primary"
                maxWidth="80px"
                onClick={onClickCancel}
            />
            <ButtonComponent
                label="Yes"
                type="secondary"
                maxWidth="80px"
                onClick={onClickYes}
            />
        </div>
    );
};

const DeleteTrainingContent = ({
    selectedTopic,
}) => {
    return (
        <div className="finalLTupdatedfooter-btn-wrapper">
            <p>
                Do you want to delete{" "}
                <b>{selectedTopic?.topic}</b>{" "}
                topic?
            </p>
        </div>
    );
};